import { render } from "./Leaderboards.vue?vue&type=template&id=b3dd8d40&scoped=true"
import script from "./Leaderboards.vue?vue&type=script&lang=ts"
export * from "./Leaderboards.vue?vue&type=script&lang=ts"

import "./Leaderboards.vue?vue&type=style&index=0&id=b3dd8d40&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b3dd8d40"

export default script